import React, {useState} from 'react';
import {useDispatch} from 'react-redux';

import {IconoirPlusCircle} from '@ey-xd/motif-icon';

import {labels} from '../../../../../util/utils';

import ACForm from './ACForm';
import ToolbarButton from '../ToolbarButton';

const AddContact = () => {
	const [showModal, setShowModal] = useState(false);

	const hideModal = () => {
		setShowModal(false);
	};

	const renderTrigger = () => {
		const props = {
			label: labels.toolbarAddContact,
			svg: IconoirPlusCircle,
			onClick: () => setShowModal(true)
		};

		return <ToolbarButton {...props} />;
	};

	const renderModal = () => {
		const props = {
			showModal,
			hideModal
		};

		return <ACForm {...props} />;
	};

	return (
		<>
			{renderTrigger()}
			{showModal && renderModal()}
		</>
	);
};

export default AddContact;
